import { Component, OnInit } from '@angular/core';
import { RolesAndPermissionsService } from '../../../../services/roles-and-permissions.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { User, UserSaved } from 'src/app/models/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { PermissionView } from 'src/app/models/permission-view.model';
import { Permission, PermissionInAdminRequest, PermissionResponse } from 'src/app/models/permission.model';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { PositionRole } from 'src/app/models/position-role.model';
import { PaginationModel } from 'src/app/models/pagination.model';
import { PaginationUtil } from 'src/app/common/util';

@Component({
  selector: 'app-user-permissions',
  templateUrl: './user-permissions.component.html',
  styleUrls: ['./user-permissions.component.scss']
})
export class UserPermissionsComponent implements OnInit {
  inputCompany = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
  inputUser = new InputAutocompleteModel("", false, true, "", "fa-asterisk", "", "", null, []);
  buttonSave = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  creatingUser = false;
  currentCompany = null;
  users: User[] = [];
  filterUsers: User[] = [];
  allCompanies: CompanyRoleResponse[] = [];
  companies: CompanyRoleResponse[] = [];
  timeout = null;
  selected: CompanyRoleResponse = null;
  userSelected = null;
  listAllPermissions = [];
  pagination = new PaginationModel(0, 5, 0, 0, [], []);
  user: UserSaved = null;
  loading: { [key: number]: boolean } = {};

  constructor(
    private roleService: RolesAndPermissionsService,
    private authService: AuthenticationService,
    private toastService: ToastrService,
  ) {
    this.currentCompany = parseInt(authService.getCurrentCompanyId());
    this.companies = JSON.parse(this.authService.getCurrentUser()).companyRoles;
    this.allCompanies = this.companies;
    this.user = this.authService.getUser();
    this.selected = new CompanyRoleResponse();
    this.selected.companyId = 809;
  }

  getPermissions() {
    this.roleService.getPermissions(809).subscribe(
      {
        next: (response) => {
          var permissions = [];
          const allPermissions = Object(response)['data'];
          for (let i = 0; i < allPermissions.length; i++) {
            const element = allPermissions[i];
            if (element.name.includes('serp_admin')) {
              const onePermissionView = new PermissionView(element.id, element.displayName);
              const onePermission = new Permission(element.id);
              onePermissionView.permission = onePermission;
              permissions.push(onePermissionView);
            }
          }
          this.listAllPermissions.push({ permissions: permissions, class: 'in-admin', placeholder: 'In Admin', icon: 'fa-user-tie' });
        },
        error: (error) => {
          this.toastService.error("Error al obtener los permisos de administración");
        }
      }
    )
  }

  ngOnInit(): void {
    this.getPermissions();
    this.getUsers();
  }

  resetUser() {
    this.getUsers();
    this.resetPermissions();
    this.inputUser.value = "";
    this.inputUser.data = null;
    this.inputUser.class = "fa-list";
  }

  deactivate(user) {
    if (this.loading[user.email]) {
      return;
    }
    this.loading[user.email] = true;
    if (this.user.contadorGT) {
      this.roleService.deactivatePartner(user.email).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Usuario desactivado!");
          this.loading[user.email] = true;
          this.resetUser();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error('Problema al obtener los usuarios de la base de datos');
          this.loading[user.email] = true;
        }
      })
    } else {
      this.roleService.deactivateUserPartner(user.email).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Usuario desactivado!");
          this.loading[user.email] = true;
          this.resetUser();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error('Problema al obtener los usuarios de la base de datos');
          this.loading[user.email] = true;
        }
      })
    }
  }

  searchCompany() {
    clearTimeout(this.timeout);
    this.inputCompany.class = "typing";
    this.timeout = setTimeout(() => {
      this.companies = this.allCompanies.filter((company) => {
        var val = this.inputCompany.value.toLowerCase();
        return company.alphanumericId.toLowerCase() == val || company.companyName.toLowerCase().includes(val) || company.companyNIT.toLowerCase().includes(val);
      });
      this.inputCompany.verified = false;
      if (this.companies.length > 0) {
        this.inputCompany.class = "fa-list";
      } else {
        this.inputCompany.class = "fa-xmark";
      }
    }, 300);
  }

  getUsers() {
    if (this.selected) {
      this.roleService.getUsersAdmin(this.selected.companyId).subscribe({
        next: (response: ResponseObject) => {
          this.users = response.data as User[];
          this.filterUsers = this.users;
          this.pagination.total = this.filterUsers;
          this.pagination = PaginationUtil.reset(this.pagination);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error('Problema al obtener los usuarios de la base de datos');
        }
      })
    } else {
      this.toastService.error("Selecciona una empresa primero");
    }
  }


  selectCompany(selected: CompanyRoleResponse) {
    this.inputCompany.value = selected.alphanumericId + " - " + selected.companyNIT + " - " + selected.companyName;
    this.inputCompany.verified = true;
    this.inputCompany.class = "fa-circle-check";
    this.selected = selected;
    this.getUsers();
  }

  searchUser() {
    this.userSelected = null;
    if (this.inputUser.value != '') {
      this.filterUsers = this.users.filter((user) => {
        return user.email.includes(this.inputUser.value)
      })
    } else {
      this.filterUsers = this.users;
    }
  }

  selectUser(user) {
    this.inputUser.value = user.email;
    this.inputUser.required = true;
    this.inputUser.verified = true;
    this.inputUser.class = "fa-circle-check";
    this.userSelected = user;
    this.resetPermissions();
    this.roleService.getRoleAdminPermissions(
      user.id
    ).subscribe({
      next: (response: ResponseObject) => {
        var res = response.data as PermissionResponse[];
        res.forEach((perm) => {
          var perms = this.listAllPermissions[0].permissions as PermissionView[];
          console.log(perms);
          for (let i = 0; i < perms.length; i++) {
            const original = perms[i];
            if (original.permission.permissionId == perm.roleId) {
              original.permission.create = perm.create;
              original.permission.delete = perm.delete;
              original.permission.update = perm.update;
              original.permission.read = perm.read;
              break;
            }
          }
        });
      },
      error: (error) => {
        this.toastService.error("Error al obtener los permisos del usuario");
      }
    })
  }

  resetPermissions() {
    var perms = this.listAllPermissions[0].permissions as PermissionView[];
    for (let i = 0; i < perms.length; i++) {
      const original = perms[i];
      original.permission.create = false;
      original.permission.delete = false;
      original.permission.update = false;
      original.permission.read = false;
    }
  }

  changePermission(type: string, permission: PermissionView, i, listPerms) {
    var valueToPut = i > -1 ? false : i == -1 ? true : false;
    if (i > -1) {
      if ((i != 0 && !listPerms[0].permission[type]) || i == 0) {
        permission.permission[type] = !permission.permission[type];
        valueToPut = permission.permission[type];
      }
    } else {
      permission.permission[type] = valueToPut;
    }
    if (permission.id == 7000) {
      this.changePermission(type, listPerms[i + 1], valueToPut ? -1 : -2, listPerms);
      this.changePermission(type, listPerms[i + 2], valueToPut ? -1 : -2, listPerms);
      this.changePermission(type, listPerms[i + 3], valueToPut ? -1 : -2, listPerms);
      this.changePermission(type, listPerms[i + 4], valueToPut ? -1 : -2, listPerms);
    }
    permission.touched = true;
  }

  savePermissions() {
    if (this.buttonSave.loading) {
      return;
    }
    this.buttonSave.loading = true;
    var permissions: Permission[] = [];
    var requestPositionRole = new PositionRole();
    requestPositionRole.position = -1;
    requestPositionRole.user = this.userSelected.id;
    this.listAllPermissions.forEach((typePermission) => {
      typePermission.permissions.forEach((permission: PermissionView) => {
        if (permission.permission.create || permission.permission.update || permission.permission.delete || permission.permission.read) {
          permissions.push(permission.permission);
        }
      });
    })
    requestPositionRole.permissions = permissions;
    this.roleService.savePositionRole(requestPositionRole, this.user.contadorGT).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Permisos creados correctamente!");
        this.buttonSave.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.buttonSave.loading = false;
      }
    })
  }

  selectedUser(user: any) {
    this.userSelected = user;
    this.selectUser(user);
  }
}
